export default __webpack_public_path__ + "static/media/mars.cc255a7d.jpg";